import React, { useEffect, useState } from 'react';
import { Alert, Button, Snackbar } from '@mui/material';


function RedirectAlert(): JSX.Element {
  const [showRedirectMessage, setShowRedirectMessage] = useState(false);

  useEffect(() => {
    const hasDismissedMessage = localStorage.getItem('legacy-redirect-dismissed') === 'true';
    
    if (!hasDismissedMessage) {
      setShowRedirectMessage(true);
    }
  }, []);

  const handleDismiss = () => {
    setShowRedirectMessage(false);
    // Mark as dismissed permanently in localStorage
    localStorage.setItem('legacy-redirect-dismissed', 'true');
  };

  return (
    <Snackbar
      open={showRedirectMessage}
      // No autoHideDuration - user must dismiss manually
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert 
        onClose={handleDismiss} 
        severity="info"
        color="warning"
        elevation={8}
        action={
          <Button 
            color="inherit" 
            size="small" 
            onClick={handleDismiss}
          >
            Dismiss
          </Button>
        }
      >
        Welcome to the new AccessElias3 finders URL!
        <p />
        Please update your bookmarks to use <strong>finders.esb.com</strong> to ensure future access.
        <p />
        Clicking Dismiss will permanently hide this message.
      </Alert>
    </Snackbar>
  );
}

export default RedirectAlert;